// --------------------------------------------------------------------------
// toggleMobileNav.js
// --------------------------------------------------------------------------
// Toggles the display of the site navigation on mobile
// --------------------------------------------------------------------------

RN.toggleMobileNav = function() {

  'use strict';

  var body = $('body'),
      siteNav = byElement('site-nav');

  function init() {
    byBehaviour('open-mobile-nav').on('click', openNav);
    byBehaviour('close-mobile-nav').on('click', closeNav);
  }

  function openNav(){
    body.addClass('nav-open');
  }

  function closeNav(){
    body.removeClass('nav-open');
    siteNav.removeClass('site-nav--show-subs');
  }

  return {
    init: init
  };

}();